<div class="canned-inspection-browse">

  <div class="canned-inspection-browse-header">
    <div class="inspection-search-box flex-start-end">
      <!-- Canned Service Browse Header -->
      <div class="flex-start-center canned-inspection-search">
        <div class="canned-inspection-search-input">
          <app-input leftIcon="fal fa-search" placeholder="Search all inspections" theme="border" [fontSize]="12"
            [value]="query" (appChange)="searchCannedInspection($event)"></app-input>
        </div>
        <div class="text-right">
          <i class="fal fa-times pointer ml-4 mr-2" (click)="close(false)"></i>
        </div>
      </div>
      <!-- Canned Service Browse Header -->
    </div>
  </div>

  <div *ngIf="!isAddCannedServicesFromInspection" class="canned-inspection-browse-body">
    <div class="canned-inspection-browse-content">
      <div class="content-header">
        <p class="mb-0 font-12 font-bold">Inspection checklist</p>
      </div>

      <div class="content-inspection">
        <app-accordian id="inspection-list-{{inspectionIndex}}"
          *ngFor="let inspection of visibleCannedInspection; let inspectionIndex = index" headerLabel="title"
          headerCountLabel="items" listItemKey="category" listItemLabel="title" [data]="inspection"
          [hasCustomSelectedItemText]="false" [hasItemCheckbox]="true" checkBoxPosition="end" [hasCustomTemplate]="true"
          [iconSize]="10" [fontSize]="12" [showSelectedItem]="true" [index]="inspectionIndex" [listItemIdKey]="'itemId'"
          [hasCustomHeader]="true" [hasHeaderCheckbox]="false">
          <!-- Start Custom Accordian Header -->
          <ng-template appTemplate="accordian-header" let-toggleAccordian="toggleAccordian">
            <div (click)="addToEstmate(inspection, inspection.isAdded, inspectionIndex, $event, toggleAccordian)"
              class="flex-between-center inspection-acc-header">
              <div class="flex-column flex-center-start">
                <span class="font-12 text-truncate canned-inspection-title">{{ currentLang ==='fr'? (inspection?.titleFR
                  || inspection?.title) : (inspection?.title || inspection?.titleFR)}}</span>
                <span class="font-10">{{renderCategoriesAndItems(inspection)}}</span>
              </div>
              <div class="">
                <div *ngIf="inspection?.isAdded" class="font-11 pointer add-est-btn btn-gray text-center btn-100 mr-3">
                  Selected
                </div>

                <button *ngIf="!inspection?.isAdded" [disabled]="!isDVIRecommendedServicesEnabled && isSelected"
                  [ngClass]="{'isSelected not-allowed': !isDVIRecommendedServicesEnabled && isSelected}"
                  class="pointer add-est-btn btn btn-white btn-border pointer btn-submit btn-white text-center btn-100 mr-3 font-11">
                  Add to {{orderTitle}}
                </button>
              </div>
            </div>
          </ng-template>
          <!-- End Custom Accordian Header -->
          <!-- Start Custom Accordian Body -->
          <ng-template let-category let-categoryIndex="index" appTemplate="accordian-item">
            <div class="category-list">
              <app-accordian [data]="category" id="sub-inspection-list-{{inspectionIndex}}" [dataIdKey]="'categoryId'"
                headerLabel="title" headerCountLabel="items" listItemKey="inspectionItems" listItemLabel="title"
                [hasCustomSelectedItemText]="true" [hasItemCheckbox]="true" checkBoxPosition="start"
                [renderSelectItemText]="renderSelectItemText" [hasCustomHeader]="true" [hasCustomTemplate]="true"
                [iconSize]="10" [fontSize]="12" [showSelectedItem]="true">
                <ng-template appTemplate="accordian-header" let-inspectionItem let-selectAll="selectAll"
                  let-toggleAccordian="toggleAccordian" let-ref="ref">
                  <div class="flex-between-center"
                    (click)="handleCategorySelect($event, category?.itemCount === category?.inspectionItems?.length, inspection, categoryIndex, toggleAccordian)">
                    <div class="flex-start-center service-acc-header">
                      <div class="custom-checkbox select-all-wrapper">
                        <span *ngIf="category?.itemCount === category?.inspectionItems?.length">
                          <i class="checkbox-icon pointer font-15 fal fa-check check-icon"></i>
                          <div class="font-12 ml-2">
                            <p class="mb-0">{{currentLang
                              ==='fr'? (category?.titleFR || category?.title) : (category?.title || category?.titleFR)
                              }}</p>
                          </div>
                        </span>
                        <span *ngIf="!category?.itemCount || category?.itemCount === 0">
                          <i class="checkbox-icon pointer font-15 fal fa-stop checkbox-icon-empty"></i>
                          <div class="font-12 ml-2">
                            <p class="mb-0">{{currentLang
                              ==='fr'? (category?.titleFR || category?.title) : (category?.title || category?.titleFR)}}
                            </p>
                          </div>
                        </span>
                        <span
                          *ngIf="category?.itemCount > 0 && category?.inspectionItems?.length > category?.itemCount">
                          <i class="checkbox-icon pointer font-15 fas fa-minus-square check-minus"></i>
                          <div class="font-12 ml-2">
                            <p class="mb-0">{{currentLang
                              ==='fr'? (category?.titleFR || category?.title) : (category?.title || category?.titleFR)}}
                            </p>
                          </div>
                        </span>
                      </div>
                    </div>
                    <div class="flex-end-center font-10">
                      {{category?.itemCount || 0}}/{{category?.inspectionItems?.length}} items selected
                    </div>
                  </div>
                </ng-template>
                <ng-template let-inspectionItem let-inspectionItemIndex="index" appTemplate="accordian-item">
                  <div class="flex-start-center inspection-item">
                    <label class="flex-start-between" for="{{inspectionIndex}}{{categoryIndex}}{{inspectionItemIndex}}"
                      class="font-12 flex-start-center pointer ml-2 mb-0 width-100p">
                      <div class="custom-checkbox">
                        <p-checkbox [(ngModel)]="inspectionItem.isChecked"
                          inputId="{{inspectionIndex}}{{categoryIndex}}{{inspectionItemIndex}}"
                          styleClass="field-checkbox font-12"
                          (onChange)="handleSelectChange($event?.checked, inspectionIndex, categoryIndex, inspection)"
                          binary="true" checkboxIcon="fal fa-check">
                        </p-checkbox>
                      </div>
                      <span class="ml-1">
                        {{currentLang ==='fr'? (inspectionItem?.titleFR || inspectionItem?.title) :
                        (inspectionItem?.title || inspectionItem?.titleFR)
                        }}
                      </span>
                    </label>
                  </div>
                </ng-template>
              </app-accordian>
            </div>
          </ng-template>
          <!-- End Custom Accordian Body -->
        </app-accordian>
      </div>

      <div class="canned-inspection-browse-footer flex-end-center">
        <button id="ro-inspection-service-submit-btn" class="btn btn-primary btn-80 btn-12 font-12"
          (click)="close(true)">Done</button>
      </div>

    </div>
  </div>

  <div *ngIf="isAddCannedServicesFromInspection" class="canned-inspection-browse-body">
    <div class="canned-inspection-browse-content">
      <div class="content-header">
        <p class="mb-0 font-12 font-bold">Inspection checklist</p>
      </div>

      <div class="content-inspection">
        <app-accordian id="inspection-list-{{inspectionIndex}}"
          *ngFor="let inspection of visibleCannedInspection; let inspectionIndex = index" headerLabel="title"
          headerCountLabel="items" listItemKey="associatedCannedServices" listItemLabel="title" [data]="inspection"
          [hasCustomSelectedItemText]="false" [hasItemCheckbox]="true" checkBoxPosition="end" [hasCustomTemplate]="true"
          [iconSize]="10" [fontSize]="12" [showSelectedItem]="true" [index]="inspectionIndex" [listItemIdKey]="'itemId'"
          [hasCustomHeader]="true" [hasHeaderCheckbox]="false">
          <!-- Start Custom Accordian Header -->
          <ng-template appTemplate="accordian-header" let-toggleAccordian="toggleAccordian">
            <div (click)="toggleInspection($event, inspection, toggleAccordian)"
              class="flex-start-center inspection-acc-header pl-0">
              <div class="flex-column flex-center-start">
                <div class="d-flex">
                  <img *ngIf="inspection.isAlCertified" src="assets/img/icon_star.svg" class="pr-2 align-self-center">
                  <span class="font-12 font-700 text-truncate">{{inspection?.title}}</span>
                  <span class="mx-2">&#8213;</span>
                  <span class="font-10 align-self-center">{{renderCategoriesAndItems(inspection)}}</span>
                </div>
                <span class="font-10"
                  [ngClass]="{'pl-4':inspection.isAlCertified}">{{getInspectionServicesCount(inspection)}} Associated
                  {{getInspectionServicesCount(inspection) === 1 ?'Service': 'Services'}}</span>
              </div>

              <!-- <div class="">
                <div *ngIf="inspection?.isAdded" class="font-11 pointer add-est-btn btn-gray text-center btn-100 mr-3">
                  Selected
                </div>

                <button *ngIf="!inspection?.isAdded" [disabled]="!isDVIRecommendedServicesEnabled && isSelected"
                  [ngClass]="{'isSelected not-allowed': !isDVIRecommendedServicesEnabled && isSelected}"
                  class="pointer add-est-btn btn btn-white btn-border pointer btn-submit btn-white text-center btn-100 mr-3 font-11">
                  Add to {{orderTitle}}
                </button>
              </div> -->
            </div>
          </ng-template>
          <!-- End Custom Accordian Header -->
          <!-- Start Custom Accordian Body -->
          <ng-template let-service let-serviceIndex="index" appTemplate="accordian-item">
            <div *ngIf="service._id" class="canned-services-list flex-between-center"
              (click)="handleCannedServicesSelect($event, service)">
              <div class="flex-start-center service-acc-header">
                <div class="custom-checkbox select-all-wrapper">
                  <span *ngIf="service.isSelected">
                    <i class="checkbox-icon pointer font-15 fal fa-check check-icon"></i>
                    <div class="font-12 font-700 ml-3">
                      <p class="mb-0">{{service?.title}}</p>
                    </div>
                  </span>
                  <span *ngIf="!service.isSelected">
                    <i class="checkbox-icon pointer font-15 fal fa-stop checkbox-icon-empty"></i>
                    <div class="font-12 font-700 ml-3">
                      <p class="mb-0">{{service?.title}}</p>
                    </div>
                  </span>
                </div>
              </div>
              <div class="flex-end-center">
                <div *ngIf="service.isSelected" class="font-11 pointer add-est-btn btn-gray text-center btn-100 mr-3">
                  Selected
                </div>

                <button *ngIf="!service.isSelected"
                  class="pointer add-est-btn btn btn-white btn-border pointer btn-submit btn-white text-center btn-100 mr-3 font-11">
                  Add to {{orderTitle}}
                </button>
              </div>
            </div>

            <div *ngIf="!service._id && service.text" class="canned-services-list text-center font-600 pl-10p">
              <span style="color: #A2A9A9;">{{service.text}}</span>
            </div>
          </ng-template>
          <!-- End Custom Accordian Body -->
        </app-accordian>
      </div>

      <div class="canned-inspection-browse-footer flex-end-center">
        <button id="ro-inspection-service-submit-btn" class="btn btn-primary btn-80 btn-12 font-12"
          (click)="close(true)">Done</button>
      </div>

    </div>
  </div>
</div>